import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenshotDetailsComponent } from './components/screenshot-details/screenshot-details.component';
import { ScreenshotViewComponent } from './components/screenshot-view/screenshot-view.component';

import { ScreenshotRoutingModule } from './screenshot-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ScreenshotDetailsComponent, ScreenshotViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    ScreenshotRoutingModule
  ]
})
export class ScreenshotModule { }
